/**
 * Third-party services the applications connect to. Each is optional and off
 * until an organisation configures it — the privacy policy makes the same
 * commitment, so keep the two lists in step.
 */
export const integrationGroups = [
    {
        title: 'Document storage',
        body: 'Attachments sync to storage you own and control — or stay on your own computers, shared between them directly.',
        items: [
            'Google Drive',
            'Microsoft OneDrive',
            'Amazon S3',
            'S3-compatible storage',
            'Your own computers (no cloud)',
        ],
    },
    {
        title: 'Vehicle tracking',
        body: 'Live positions from the GPS provider your fleet already uses.',
        items: ['iAlert', 'WheelsEye', 'Geomatics'],
    },
    {
        title: 'Fuel cards',
        body: 'Balances, card limits, status, PIN control, and transaction history.',
        items: ['BPCL', 'Reliance (RIL)'],
    },
    {
        title: 'Banking and tolls',
        body: 'Statement lines and toll charges land beside the trips they belong to.',
        items: ['NETC toll transactions'],
    },
    {
        title: 'Maps and routing',
        body: 'Geocoding and route distance, cached so the same lookup is never paid for twice.',
        items: ['Google Maps', 'OpenStreetMap'],
    },
    {
        title: 'Messaging',
        body: 'Invoices, statements and payment reminders go to the party by email, or from your organisation’s own WhatsApp number.',
        items: ['WhatsApp Business (Meta Cloud API)', 'Email'],
    },
    {
        title: 'Accounting and freight',
        body: 'Hand finished work to the systems the rest of the business runs on.',
        items: ['Tally export'],
    },
];
//# sourceMappingURL=integrations.js.map